import React from 'react'
import {
  MyLocationBanner,
  MyLocationBannerProps
} from '@dcxwam/dcx-wam-ui-foundations'
import { saveLocalizationCookie } from '../utils'
import { NormalizedLocationData } from '../types'

export const ChangeMyLocationMock = () => {
  const mockLocation: NormalizedLocationData = {
    stateISOCode: 'TX',
    stateFullname: 'Texas',
    stateShortname: 'TX',
    city: 'Conroe',
    zip: '77301',
    countryCode: 'US'
  }

  saveLocalizationCookie(mockLocation)

  const bannerProps: MyLocationBannerProps = {
    statecode: 'AR',
    zipcode: '12345',
    onClick: (): void => {
      throw new Error('Function not implemented.')
    },
    myLocationLabel: 'My Location: ',
    isCommercialized: false,
    errorMessage: 'Shipping not available'
  }

  return <MyLocationBanner {...bannerProps} />
}
